module.exports = __webpack_public_path__ + "media/images/chef-7f61cb53c6279e3e9b81e1db52cd05d8.jpg";